import React from 'react';

import Typography from '@mui/material/Typography';

import { DividerContainer } from './styledInfoComponents';

interface Props {
    label: string;
}

const InfoDivider: React.FC<Props> = props => {
    return (
        <DividerContainer>
            <Typography
                fontSize="11px"
                fontWeight="700"
                textTransform="uppercase"
            >
                {props.label}
            </Typography>
        </DividerContainer>
    );
};

export default InfoDivider;
